export interface SearchProps {
  queryString: string;
  nonProfitAdvanceFilters: {
    [key: string]: any;
    category: string;
    city: string;
    state: string;
    zipcode: number;
    coordinates: { lng?: number; lat?: number };
    active_campaign: boolean;
    domestic: boolean;
    international: boolean;
    distance: number;
  };
  campaignAdvanceFilters: {
    [key: string]: any;
    topic: string;
    startDate: string;
    endDate: string;
  };
  eventAdvanceFilters: {
    [key: string]: any;
    city: string;
    state: string;
    topic: string;
    startDate: string;
    endDate: string;
  };
  showAllResults: boolean;
  searchCategory: string;
}

export interface NonProfitResultProps {
  _id: number;
  name: string;
  category: string;
  about: string;
  images: {
    logo: string;
    banner: string;
    profile: string;
  };
  address: {
    addressLine1: string;
    addressLine2?: string;
    city: string;
    state: string;
    zip: number;
  };
  active_campaign: boolean;
}

export interface CampaignResultProps {
  _id: string;
  name: string;
  description: string;
  imageURL: string;
  imageAlt: string;
  nonprofits: Array<{
    _id: string;
    address: { city: string; state: string };
    name: string;
    images: { logo: string };
    stripeComplete: boolean;
    paypal?: {
      merchantId?: string;
      merchantIdInPayPal?: string;
    };
  }>;
  peopleDonated: number;
  targetAudienceState: string;
  targetAudienceCity: string;
  goal: number;
  raised: number;
  endDate: string;
  slug?: string;
}

export interface EventResultProps {
  _id: string;
  name: string;
  description: string;
  imageURL: string;
  imageAlt: string;
  targetAudienceState: string;
  targetAudienceCity: string;
  goal: number;
  raised: number;
  startDate: string;
  endDate: string;
  followers: number;
}

export enum EnumCategory {
  NonProfits = 'NonProfits',
  Campaigns = 'Campaigns',
  Events = 'Events'
}

export const defaultSearchFilters: SearchProps = {
  queryString: '',
  nonProfitAdvanceFilters: {
    category: '',
    city: '',
    state: '',
    zipcode: 0,
    coordinates: { lng: undefined, lat: undefined },
    active_campaign: false,
    domestic: false,
    international: false,
    distance: 0
  },
  campaignAdvanceFilters: {
    topic: '',
    startDate: '',
    endDate: ''
  },
  eventAdvanceFilters: {
    city: '',
    state: '',
    topic: '',
    startDate: '',
    endDate: ''
  },
  showAllResults: false,
  searchCategory: EnumCategory.NonProfits
};
